<section [class.view-contract-loading]="isLoading">
  @if (isLoading) {
  <div class="view-contract-loading-box">
    <span>
      <i class="fas fa-spinner fa-spin me-2"></i>Loading...
    </span>
  </div>
  }

  @if (pdf?.data?.pdfRaw && src) {
    <div class="view-contract pdf-iframe">
      <!-- <pdf-viewer
      [src]="src"
      [render-text]="true"
      [original-size]="false"
      style="height: 100%">
    </pdf-viewer> -->
    <iframe [attr.src]="src" style="height: 100%; width:100%; border:0"></iframe>
  </div>
  }

  @if (pdf?.data?.pdfRaw && src) {
  <div class="text-center mt-2 mb-2">
    <a role="link" tabindex="0" class="blue-link uppercase" mdbWavesEffect id="download-contract-button"
      (click)="downloadPDF()">{{
      'MY_ACCOUNT_LOGIN.DOWNLOAD_CONTRACT' | translate }}
    </a>
  </div>
  }


  @if (!pdf?.data?.pdfRaw && !isLoading && newWelcomeFlow) {
  <div class="parent">
    <div class="centered-div text-center">
      <h2 class="header">Customer Agreement</h2>
      <!-- <p>Please call {{branding.cs_phone_number}} for assistance.</p> -->
       @if (!linkClicked) {
        <p>Sorry, the link to your Customer Agreement has expired.</p>
        @if (emailLinkError) {
          <p class="text-danger mb-2">{{ emailLinkError }}</p>
        }
        <button type="button" class="btn primary-btn mt-2" id="email-new-link-button"
          (click)="updateLinkExpiration()" [disabled]="emailLinkLoading" aria-label="Email new link">
          @if (emailLinkLoading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Sending...
          } @else {
            Email New Link
          }
        </button>
        <p class="warningMessage">This link expires 15 minutes from when its clicked</p>
       } @else {
        <p>Your new link has been sent!</p>
       }

    </div>
  </div>
  } @else if (!pdf?.data?.pdfRaw && !isLoading && !newWelcomeFlow) {
    <div class="parent">
      <div class="centered-div text-center">
          <p>Sorry, the link to your Customer Agreement has expired.</p>
          <p>Please call {{branding?.cs_phone_number}} for assistance.</p>
      </div>
    </div>
  }
</section>